import { notFound } from 'next/navigation';

import { getChannel, getContent } from '@lib/server';
import type { Place } from '@types';

export async function getCollinsWidgetData(domain: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) notFound();

  const places = await getContent<Place>('place')
    .setDepth(0)
    .setTags([channel.channelId])
    .setWhere([['sys.channels', 'contains', channel.id]])
    .fetch(['fields.name', 'fields.apps', 'fields.custom.slug', 'fields.custom.displayName'])
    .then((data) => data?.map(({ fields }) => ({ ...fields })));

  return {
    venues:
      places
        ?.filter((place) => place.apps?.designMyNight?.active)
        ?.map((place) => ({
          /** Place Slug */
          venue: place?.custom?.slug,
          /** Place DesignMyNight ID */
          id: place?.apps?.designMyNight?.id,
        })) || [],
    tagManagerCode: channel?.apps?.googleTagManager?.active ? channel?.apps?.googleTagManager?.id : undefined,
  };
}
